import type { ReactNode } from 'react'
import { Outlet } from 'react-router-dom'
import { useTenantType } from '@/hooks/useModule'

export function TenantTypeGuard({
  type,
  children,
  fallback = null,
}: {
  type: 'store' | 'website'
  children?: ReactNode
  fallback?: ReactNode
}) {
  const tenantType = useTenantType()

  if (tenantType !== type) {
    return <>{fallback}</>
  }

  return children ? <>{children}</> : <Outlet />
}
